import type { CatalogInApp } from '~/interfaces/app';

const pagesWithoutSeoData: string[] = [
  'about',
  'checkout',
  'checkout/approve',
  'checkout/thank-you',
  'favorite',
  'compare',
  'search',
  'error',
  'contacts',
  'press',
  'confirmation',
  'user-agreement',
  'cabinet',
  'cabinet-orders',
  'cabinet-addresses',
  'cabinet-profile',
  'cabinet-notification',
  'cabinet-help',
  'cabinet-help-slug',
  'purchase-terms',
  'mobile-purchase-terms',
  'recommendation-system',
  'legal',
  'account-deleted',
  'news',
  'promo-slug',
  'oplata-i-dostavka',
  'obmen-vozvrat-garantiya',
  'kak-oformit-zakaz',
];
const countryPhoneCode = 7;
const phoneMask = `+{${countryPhoneCode}} (000) 000-00-00`;
const maxAge: number = 1000 * 60 * 60 * 24 * 365;
const sessionMaxAge = 1800;
const dayMaxAge = 86400;
const cookiesMaxAge: number = 60 * 60 * 24 * 30; // В секундах = 2592000, т.е. 30 дней
const timeOrActionTimer: number = 1800000; // 0.5 часа

const webviewUrls: string[] = [
  'error',
  'confirmation',
  'user-agreement',
  'purchase-terms',
  'mobile-purchase-terms',
  'legal',
];

const cookieNames = {
  newSite: 'new-site',
  oldSite: 'old-site',
  debugAll: 'all',
  debugPanel: 'cp',
  orderId: 'order_id',
  removeAccount: 'remove-account',
};

const cachedPageMeta: {
  [key: string]: {
    title: string;
    description: string;
    is_active: boolean;
  };
} = {
  about: {
    title: 'Информация о компании - Price.ru',
    description: 'Актуальная информации о компании ООО Прайс Экспресс',
    is_active: true,
  },
  legal: {
    title: 'Правовая информация - Price.ru',
    description: 'Правовая информация - Price.ru',
    is_active: true,
  },
  contacts: {
    title: 'Контактная информация - Price.ru',
    description: 'Контактная информация - Price.ru',
    is_active: true,
  },
  press: {
    title: 'Информация для прессы - Price.ru',
    description: 'Информация для журналистов и других представителей прессы',
    is_active: true,
  },
  'user-agreement': {
    title: 'Пользовательское соглашение - Price.ru',
    description: 'Полный текст пользовательского соглашения - Price.ru',
    is_active: true,
  },
  'purchase-terms': {
    title: 'Правила покупки на сайте Price.ru',
    description: 'Правила покупки на сайте Price.ru',
    is_active: true,
  },
  'mobile-purchase-terms': {
    title: 'Правила покупки в мобильном приложении Price.ru',
    description: 'Правила покупки в мобильном приложении Price.ru',
    is_active: true,
  },
  'recommendation-system': {
    title: 'Рекомендательная система - Price.ru',
    description: 'Рекомендательная система - Price.ru',
    is_active: true,
  },
  favorite: {
    title: 'Избранное - Price.ru',
    description: 'Избранное - Price.ru',
    is_active: true,
  },
  compare: {
    title: 'Сравнение товаров - Price.ru',
    description: 'Сравнение товаров - Price.ru',
    is_active: true,
  },
};

const sortListings = [
  {
    id: 1,
    value: 'popularity',
    name: 'Сначала популярное',
  },
  {
    id: 2,
    value: 'price-asc',
    name: 'Сначала дешевые',
  },
  {
    id: 3,
    value: 'price-desc',
    name: 'Сначала дорогие',
  },
  {
    id: 4,
    value: 'discount',
    name: 'По скидке',
  },
  {
    id: 5,
    value: 'reviews',
    name: 'По количеству отзывов',
  },
  {
    id: 6,
    value: 'rating',
    name: 'По рейтингу',
  },
];
const sortMarket = [
  {
    id: 1,
    value: 'popularity',
    name: 'Сначала популярное',
  },
  {
    id: 2,
    value: 'price-asc',
    name: 'Сначала дешевые',
  },
  {
    id: 3,
    value: 'price-desc',
    name: 'Сначала дорогие',
  },
  {
    id: 4,
    value: 'discount',
    name: 'По скидке',
  },
];

const tokens = {
  refresh_token: 'rt',
  access_token: 'at',
};

const monthsDelivery = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

const listingsPageBlocks = 1;
const discountMiddlePercent = 20;
const discountHighPercent = 40;
const discountMiddle = 1000;
const discountHigh = 3000;

const getFirstDateOfMonth = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1).toISOString();
};

export const iosAppLink =
  'https://apps.apple.com/ru/app/price-ru-%D1%81%D1%80%D0%B0%D0%B2%D0%BD%D0%B8-%D0%B8-%D0%BA%D1%83%D0%BF%D0%B8/id1578714783?l=en';
export const androidAppLink =
  'https://play.google.com/store/apps/details?id=ru.price';

const defaultCatalog: CatalogInApp[] = [
  {
    title: 'Электроника',
    url: 'portativnaya-tehnika',
    image: 'https://static.price.ru/-/collection/menu/stickers/electr.svg',
    expand_title: 'Вся электроника',
    children: [
      {
        title: 'Мобильные телефоны и аксессуары',
        url: 'telefony-svyaz',
      },
    ],
  },
  {
    title: 'Компьютеры',
    url: 'kompyutery',
    image: 'https://static.price.ru/-/collection/menu/stickers/med.svg',
    expand_title: 'Все компьютеры и комплектующие',
    children: [],
  },
  {
    title: 'Бытовая техника',
    url: 'bytovaya-tehnika',
    image: 'https://static.price.ru/-/collection/menu/stickers/byt_teh.svg',
    expand_title: 'Вся бытовая техника',
    children: [],
  },
  {
    title: 'Авто',
    url: 'avto-moto-zapchasti',
    image: 'https://static.price.ru/-/collection/menu/stickers/avto.svg',
    expand_title: 'Все автотовары',
    children: [],
  },
  {
    title: 'Детские товары',
    url: 'detskie-tovary',
    image: 'https://static.price.ru/-/collection/menu/stickers/dets.svg',
    expand_title: 'Все детские товары',
    children: [],
  },
  {
    title: 'Дом и дача',
    url: 'tovary-dlya-dachi',
    image: 'https://static.price.ru/-/collection/menu/stickers/dom.svg',
    expand_title: 'Всё для дома и дачи',
    children: [],
  },
  {
    title: 'Мебель',
    url: 'mebel',
    image: 'https://static.price.ru/-/collection/menu/stickers/sport.svg',
    expand_title: 'Мебель',
    children: [],
  },
  {
    title: 'Красота и здоровье',
    url: 'parfyumeriya-i-kosmetika',
    image: 'https://static.price.ru/-/collection/menu/stickers/kras.svg',
    expand_title: 'Все товары для красоты',
    children: [],
  },
  {
    title: 'Спорт и отдых',
    url: 'tovary-dlya-sporta-i-turizma',
    image: 'https://static.price.ru/-/collection/menu/stickers/sport.svg',
    expand_title: 'Всё для спорта',
    children: [],
  },
  {
    title: 'Строительство и ремонт',
    url: 'remont-i-otdelka',
    image: 'https://static.price.ru/-/collection/menu/stickers/stroi.svg',
    expand_title: 'Всё для ремонта',
    children: [],
  },
  {
    title: 'Инструменты',
    url: 'instrumenty',
    image: 'https://static.price.ru/-/collection/menu/stickers/18plus.svg',
    expand_title: 'Все инструменты',
    children: [],
  },
  {
    title: 'Одежда и обувь',
    url: 'odezhda-i-obuv',
    image: 'https://static.price.ru/-/collection/menu/stickers/odezh.svg',
    expand_title: 'Вся одежда и обувь',
    children: [],
  },
  {
    title: 'Товары для животных',
    url: 'tovary-dlya-zhivotnyh',
    image: 'https://static.price.ru/-/collection/menu/stickers/zhivotn.svg',
    expand_title: 'Все товары для животных',
    children: [],
  },
  {
    title: 'Продукты питания',
    url: 'produkty',
    image: 'https://static.price.ru/-/collection/menu/stickers/prod.svg',
    expand_title: 'Все продукты',
    children: [],
  },
];

const numberTitles = (number: number, titles: string[]) => {
  if (!number) return '';
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
};
const addRobotsPages = [
  'brand',
  'category-preset',
  'category-list',
  'category-brand',
  'catalog-category',
];
export {
  addRobotsPages,
  numberTitles,
  defaultCatalog,
  pagesWithoutSeoData,
  maxAge,
  countryPhoneCode,
  phoneMask,
  sortListings,
  cachedPageMeta,
  cookieNames,
  tokens,
  monthsDelivery,
  webviewUrls,
  listingsPageBlocks,
  getFirstDateOfMonth,
  sessionMaxAge,
  cookiesMaxAge,
  discountHighPercent,
  discountMiddlePercent,
  discountHigh,
  discountMiddle,
  dayMaxAge,
  sortMarket,
  timeOrActionTimer,
};
